import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import { FeatureFlags, PermissionTypeEnum } from 'types/user-profile';
import { Navigate } from 'react-router-dom';
import useAuth from 'hooks/useAuth';

const ForbiddenAccess = Loadable(lazy(() => import('views/pages/StaticContentPages/ForbiddenAccess')));
const ForbiddenAccess1 = Loadable(lazy(() => import('views/pages/StaticContentPages/ForbiddenAccess_b')));
// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
// const DashboardAnalytics = Loadable(lazy(() => import('views/dashboard/analytics')));
const Dashboard = Loadable(lazy(() => import('views/dashboard/managerDashboard')));
const Dashboard2 = Loadable(lazy(() => import('views/dashboard/BillingDashboard')));
const MediaDashboard2 = Loadable(lazy(() => import('views/dashboard/MediaDashboard2')));


// widget routing
const WidgetStatistics = Loadable(lazy(() => import('views/widget/Statistics')));
const WidgetData = Loadable(lazy(() => import('views/widget/Data')));
const WidgetChart = Loadable(lazy(() => import('views/widget/Chart')));

// application - user social & account profile routing
const AppUserSocialProfile = Loadable(lazy(() => import('views/application/users/social-profile')));
const AppUserAccountProfile1 = Loadable(lazy(() => import('views/application/users/account-profile/Profile1')));
const AppUserAccountProfile2 = Loadable(lazy(() => import('views/application/users/account-profile/Profile2')));
const AppUserAccountProfile3 = Loadable(lazy(() => import('views/application/users/account-profile/Profile3')));

//  Accounts
const AccountsLists = Loadable(lazy(() => import('views/application/accounts')));
const AccountSettings = Loadable(lazy(() => import('views/application/accounts/AccountMaint/index')));
const SubAccountsLists = Loadable(lazy(() => import('views/application/accounts')));
const ActivitiesLists = Loadable(lazy(() => import('views/application/activities')));
const ChannelTypesLists = Loadable(lazy(() => import('views/application/accounts/channelTypes')));
const MediaMixLists = Loadable(lazy(() => import('views/application/mediaMixes')));
const MediaMixReport = Loadable(lazy(() => import('views/application/mediaMixes/reports')));
const AccountGroupTypePromptsLists = Loadable(lazy(() => import('views/application/accounts/GroupPrompts')));
const MediaMixApproval = Loadable(lazy(() => import('views/application/mediaMixes/approval')));

// Reports
const PerformanceLists = Loadable(lazy(() => import('views/application/reports/performance')));
const SystemMonitoringLists = Loadable(lazy(() => import('views/application/reports/systemMonitoring')));
const AI_AnalyticsPage = Loadable(lazy(() => import('views/application/aiAnalytics')));
// AI report chat (feature ai.analytics_v2, bs_backups/ai_report_chat)
const AiReportChatPage = Loadable(lazy(() => import('views/application/aiReportChat')));
const PendingApprovalsLists= Loadable(lazy(() => import('views/application/reports/mediaPlanApprovals')));
const BillingLists= Loadable(lazy(() => import('views/application/reports/billing')));
const CreativesReport = Loadable(lazy(() => import('views/application/reports/creatives')));
const BenchmarksScreen = Loadable(lazy(() => import('views/application/reports/benchmarks')));
const ClientConfirmationsLists = Loadable(lazy(() => import('views/application/reports/clientConfirmations')));
const TasksLists = Loadable(lazy(() => import('views/application/reports/tasks')));
const MediaServeLists = Loadable(lazy(() => import('views/application/reports/mediaServe')));
const AiUsageLists = Loadable(lazy(() => import('views/application/reports/aiUsage')));

// const MediaMixChannels= Loadable(lazy(() => import('views/application/mediaMixes/mediaChannels')));
const CampaignsLists = Loadable(lazy(() => import('views/application/campaigns')));
const ConnectorsLists = Loadable(lazy(() => import('views/application/connectors/Account')));
const GlobalConnectorsLists = Loadable(lazy(() => import('views/application/connectors/Global')));
const GlobalPromptsLists = Loadable(lazy(() => import('views/application/aiAnalytics/GlobalPrompts')));
const Global_features = Loadable(lazy(() => import('views/application/global_features')));
const AgentConnectorsLists = Loadable(lazy(() => import('views/application/connectors/Agent/index')));
const AgentExchangeRates = Loadable(lazy(() => import('views/application/AgentSettings/ExchangeRates')));
const AgentGeneralSettings= Loadable(lazy(() => import('views/application/AgentSettings')));
const MediaPlanApprovalsLists= Loadable(lazy(() => import('views/application/AgentSettings/MediaPlanApproval')));
const ChannelMaterialNumbersLists= Loadable(lazy(() => import('views/application/AgentSettings/ChannelMaterialNumbers')));
const AccountsChannelTypeLists= Loadable(lazy(() => import('views/application/AgentSettings/ChannelTypes')));
const AgentAiSettings= Loadable(lazy(() => import('views/application/AgentSettings/AiSettings')));

const CustomColumnsList = Loadable(lazy(() => import('views/application/mediaMixes/dymanicFields')));
const TemplatesList = Loadable(lazy(() => import('views/application/mediaMixes/templates')));

// IOT User
const UsersLIst = Loadable(lazy(() => import('views/application/usersiot/userslist')));
const UserEdit = Loadable(lazy(() => import('views/application/usersiot/useredit/')));

// application - user cards & list variant routing

const AppProfileCardStyle1 = Loadable(lazy(() => import('views/application/users/card/CardStyle1')));
const AppProfileCardStyle2 = Loadable(lazy(() => import('views/application/users/card/CardStyle2')));
const AppProfileCardStyle3 = Loadable(lazy(() => import('views/application/users/card/CardStyle3')));
const AppProfileListStyle1 = Loadable(lazy(() => import('views/application/users/list/Style1')));
const AppProfileListStyle2 = Loadable(lazy(() => import('views/application/users/list/Style2')));

// application - customer routing
const AppCustomerList = Loadable(lazy(() => import('views/application/customer/CustomerList')));
const AppCustomerOrderList = Loadable(lazy(() => import('views/application/customer/OrderList')));
const AppCustomerCreateInvoice = Loadable(lazy(() => import('views/application/customer/CreateInvoice')));
const AppCustomerOrderDetails = Loadable(lazy(() => import('views/application/customer/OrderDetails')));
const AppCustomerProduct = Loadable(lazy(() => import('views/application/customer/Product')));
const AppCustomerProductReview = Loadable(lazy(() => import('views/application/customer/ProductReview')));

// application routing

const AppChat = Loadable(lazy(() => import('views/application/chat')));
const AppKanban = Loadable(lazy(() => import('views/application/kanban')));

const AppKanbanBoard = Loadable(lazy(() => import('views/application/kanban/Board')));
const AppMail = Loadable(lazy(() => import('views/application/mail')));
const AppCalendar = Loadable(lazy(() => import('views/application/calendar')));
const AppContactCard = Loadable(lazy(() => import('views/application/contact/Card')));
const AppContactList = Loadable(lazy(() => import('views/application/contact/List')));

// forms component routing
const FrmComponentsTextfield = Loadable(lazy(() => import('views/forms/components/TextField')));
const FrmComponentsButton = Loadable(lazy(() => import('views/forms/components/Button')));
const FrmComponentsCheckbox = Loadable(lazy(() => import('views/forms/components/Checkbox')));
const FrmComponentsRadio = Loadable(lazy(() => import('views/forms/components/Radio')));
const FrmComponentsSwitch = Loadable(lazy(() => import('views/forms/components/Switch')));
const FrmComponentsAutoComplete = Loadable(lazy(() => import('views/forms/components/AutoComplete')));
const FrmComponentsSlider = Loadable(lazy(() => import('views/forms/components/Slider')));
const FrmComponentsDateTime = Loadable(lazy(() => import('views/forms/components/DateTime')));

// forms plugins layout
const FrmLayoutLayout = Loadable(lazy(() => import('views/forms/layouts/Layouts')));
const FrmLayoutMultiColumnForms = Loadable(lazy(() => import('views/forms/layouts/MultiColumnForms')));
const FrmLayoutActionBar = Loadable(lazy(() => import('views/forms/layouts/ActionBar')));
const FrmLayoutStickyActionBar = Loadable(lazy(() => import('views/forms/layouts/StickyActionBar')));

// forms plugins routing
const FrmAutocomplete = Loadable(lazy(() => import('views/forms/plugins/AutoComplete')));
const FrmMask = Loadable(lazy(() => import('views/forms/plugins/Mask')));
const FrmClipboard = Loadable(lazy(() => import('views/forms/plugins/Clipboard')));
const FrmRecaptcha = Loadable(lazy(() => import('views/forms/plugins/Recaptcha')));
const FrmWysiwugEditor = Loadable(lazy(() => import('views/forms/plugins/WysiwugEditor')));
const FrmModal = Loadable(lazy(() => import('views/forms/plugins/Modal')));
const FrmTooltip = Loadable(lazy(() => import('views/forms/plugins/Tooltip')));

// table routing
const TableBasic = Loadable(lazy(() => import('views/forms/tables/TableBasic')));
const TableDense = Loadable(lazy(() => import('views/forms/tables/TableDense')));
const TableEnhanced = Loadable(lazy(() => import('views/forms/tables/TableEnhanced')));
const TableData = Loadable(lazy(() => import('views/forms/tables/TableData')));
const TableCustomized = Loadable(lazy(() => import('views/forms/tables/TablesCustomized')));
const TableStickyHead = Loadable(lazy(() => import('views/forms/tables/TableStickyHead')));
const TableCollapsible = Loadable(lazy(() => import('views/forms/tables/TableCollapsible')));

// forms validation
const FrmFormsValidation = Loadable(lazy(() => import('views/forms/forms-validation')));
const FrmFormsWizard = Loadable(lazy(() => import('views/forms/forms-wizard')));

// chart routing
const ChartApexchart = Loadable(lazy(() => import('views/forms/chart/Apexchart')));
const OrgChartPage = Loadable(lazy(() => import('views/forms/chart/OrgChart')));

// basic ui-elements routing
const BasicUIAccordion = Loadable(lazy(() => import('views/ui-elements/basic/UIAccordion')));
const BasicUIAvatar = Loadable(lazy(() => import('views/ui-elements/basic/UIAvatar')));
const BasicUIBadges = Loadable(lazy(() => import('views/ui-elements/basic/UIBadges')));
const BasicUIBreadcrumb = Loadable(lazy(() => import('views/ui-elements/basic/UIBreadcrumb')));
const BasicUICards = Loadable(lazy(() => import('views/ui-elements/basic/UICards')));
const BasicUIChip = Loadable(lazy(() => import('views/ui-elements/basic/UIChip')));
const BasicUIList = Loadable(lazy(() => import('views/ui-elements/basic/UIList')));
const BasicUITabs = Loadable(lazy(() => import('views/ui-elements/basic/UITabs')));

// advance ui-elements routing
const AdvanceUIAlert = Loadable(lazy(() => import('views/ui-elements/advance/UIAlert')));
const AdvanceUIDialog = Loadable(lazy(() => import('views/ui-elements/advance/UIDialog')));
const AdvanceUIPagination = Loadable(lazy(() => import('views/ui-elements/advance/UIPagination')));
const AdvanceUIProgress = Loadable(lazy(() => import('views/ui-elements/advance/UIProgress')));
const AdvanceUIRating = Loadable(lazy(() => import('views/ui-elements/advance/UIRating')));
const AdvanceUISnackbar = Loadable(lazy(() => import('views/ui-elements/advance/UISnackbar')));
const AdvanceUISkeleton = Loadable(lazy(() => import('views/ui-elements/advance/UISkeleton')));
const AdvanceUISpeeddial = Loadable(lazy(() => import('views/ui-elements/advance/UISpeeddial')));
const AdvanceUITimeline = Loadable(lazy(() => import('views/ui-elements/advance/UITimeline')));
const AdvanceUIToggleButton = Loadable(lazy(() => import('views/ui-elements/advance/UIToggleButton')));
const AdvanceUITreeview = Loadable(lazy(() => import('views/ui-elements/advance/UITreeview')));

// pricing page routing
const PagesPrice1 = Loadable(lazy(() => import('views/pages/pricing/Price1')));
const PagesPrice2 = Loadable(lazy(() => import('views/pages/pricing/Price2')));

// utilities routing
const UtilsTypography = Loadable(lazy(() => import('views/utilities/Typography')));
const UtilsColor = Loadable(lazy(() => import('views/utilities/Color')));
const UtilsShadow = Loadable(lazy(() => import('views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(lazy(() => import('views/utilities/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('views/utilities/TablerIcons')));
const UtilsAnimation = Loadable(lazy(() => import('views/utilities/Animation')));
const UtilsGrid = Loadable(lazy(() => import('views/utilities/Grid')));

//  sample page routing
const SamplePage = Loadable(lazy(() => import('views/sample-page')));

//   ==============================|| MAIN ROUTING ||============================== //
function RequirePermission({ permissions, feature, children }: {  // accountAccessPermissions
    permissions?: PermissionTypeEnum[];
    // the user's feature flag the page is shown under (bs.Users.Features)
    feature?: FeatureFlags;
  ///  accountAccessPermissions?: AccountAccessPermissions;
    children: JSX.Element }) {
    const { user } = useAuth();
    if (feature && !user?.features?.includes(feature))
        return <Navigate to="/forbidden" replace />;

   // const { CurrentAccount} = useGlobal(); 
  const userPermissions = user?.permissions;
  
  
  let allow;
  

  if (permissions && userPermissions) {
    allow = userPermissions.filter(p => permissions.includes(p)).length > 0;
  }

//   if(allow != true){
//     // only if no permission we check access permission
//     if(accountAccessPermissions && CurrentAccount){
//         if(accountAccessPermissions.AccountSettings && CurrentAccount.AccessPermissions?.AccountSettings == true){
//             allow = true;
//         }
//         if(accountAccessPermissions.ActivitySettings && CurrentAccount.AccessPermissions?.ActivitySettings == true){
//             allow = true;
//         }
//         if(accountAccessPermissions.MediaPlanSettings && CurrentAccount.AccessPermissions?.MediaPlanSettings == true){
//             allow = true;
//         }
//         if(accountAccessPermissions.ReadOnly && CurrentAccount.AccessPermissions?.ReadOnly == true){
//             allow = true;
//         }
//     }
//   }
  

  if(allow == false){
        // Redirect to fallback page
        return <Navigate to="/forbidden" replace />;
  }

  return children;
}

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/accounts/list',
            element: <AccountsLists />
        },
        {
            path: '/accounts/:accountId/subAccounts/list',
            element: <SubAccountsLists />
        },
        {
            path: '/accounts/:accountId/settings',
            element: <AccountSettings />
        },
        {
            path: '/accounts/:mainAccountId/subAccounts/:accountId/settings',
            element: <AccountSettings />
        },
         {
            path: '/accounts/:accountId/activities/list',
            element: <ActivitiesLists />
        }, 
        {
            path: '/accounts/:accountId/channelTypes/list',
            element: <ChannelTypesLists />
        },
        {
            path: '/accounts/:accountId/groupTypePrompts/list',
            element: <AccountGroupTypePromptsLists />
        },
        {
            path: '/globalSettings/channelTypes/list',
            element: <ChannelTypesLists />
        },
        {
            path: '/accounts/:accountId/connectors/list',
            element: <ConnectorsLists />
        },
        {
            path: '/globalSettings/connectors/list',
            element: <GlobalConnectorsLists />
        },
        {
            path: '/globalSettings/globalAI/settings',
            element: <GlobalPromptsLists />
        },
        {
            path: '/globalSettings/features/list',
            element: <Global_features />
        },
        
        {
            path: '/agentSettings/connectors/list',
            element: <RequirePermission permissions={[PermissionTypeEnum.GeneralSettings]}>
                        <AgentConnectorsLists isCallBack={false} />
                    </RequirePermission>
        },
         {
            path: '/agentConnector/:channelTypeId/callback',
            element: <RequirePermission permissions={[PermissionTypeEnum.GeneralSettings]}>
                        <AgentConnectorsLists isCallBack />
                    </RequirePermission>
        },
        {
            path:'/agentSettings/mediaPlanApprovals/list',
            element: <RequirePermission permissions={[PermissionTypeEnum.GeneralSettings]}>
                <MediaPlanApprovalsLists />
            </RequirePermission>
        },
        {
            path:'/agentSettings/materialNumbers/list',
            element: <RequirePermission permissions={[PermissionTypeEnum.GeneralSettings]}>
                <ChannelMaterialNumbersLists />
            </RequirePermission>
        },
        {
            path:'/agentSettings/channelTypes/list',
            element: <RequirePermission permissions={[PermissionTypeEnum.Admin]}>
                <AccountsChannelTypeLists />
            </RequirePermission>
        },

        
        {
            path:'/pendingApprovals/list',
            element: <RequirePermission permissions={[PermissionTypeEnum.MediaPlanApprover]}>
                <PendingApprovalsLists />
            </RequirePermission>
        },
        {
            path:'/tasks/list',
            element: <TasksLists />
        },
        {
            path:'/creatives/report',
            element: <RequirePermission permissions={[PermissionTypeEnum.OperationalReports]}>
                <CreativesReport />
            </RequirePermission>
        },
        {
            path:'/benchmarks',
            element: <RequirePermission permissions={[PermissionTypeEnum.OperationalReports]}>
                <BenchmarksScreen />
            </RequirePermission>
        },
        {
            path:'/billing/list',
            element: <RequirePermission permissions={[PermissionTypeEnum.OperationalReports]}>
                <BillingLists />
            </RequirePermission>
        },
        {
            path:'/confirmations/list',
            element: <RequirePermission permissions={[PermissionTypeEnum.OperationalReports]}>
                <ClientConfirmationsLists />
            </RequirePermission>
        },
        
        {
            path: '/mediaServe/list',
            element: <RequirePermission permissions={[PermissionTypeEnum.ManagementReports]}>
                <MediaServeLists />
            </RequirePermission>
        },
        {
            path: '/ai_usage/list',
            element: <RequirePermission permissions={[PermissionTypeEnum.Admin]}>
                <AiUsageLists />
            </RequirePermission>
        },
        {
            path: '/agentSettings/exchange_rates/list',
            element: <RequirePermission permissions={[PermissionTypeEnum.GeneralSettings]}>
                        <AgentExchangeRates />
                    </RequirePermission>
        },
        {
            path: '/agentSettings/configurations',
            element: <RequirePermission permissions={[PermissionTypeEnum.GeneralSettings]}>
                        <AgentGeneralSettings />
                    </RequirePermission>
        },
        {
            path: '/agentSettings/agentAI/settings',
            element: <RequirePermission permissions={[PermissionTypeEnum.GeneralSettings]}>
                        <AgentAiSettings />
                    </RequirePermission>
        },
        {
            path: '/performance/list',
            element: <RequirePermission permissions={[PermissionTypeEnum.OperationalReports]}>
                        <PerformanceLists />
                    </RequirePermission>
        },
        {
            path: '/systemMonitoring',
            element: <SystemMonitoringLists />
        },
        {
            path: '/ai_analytics',
            element: <AI_AnalyticsPage />
        },
        {
            path: '/ai_report_chat',
            element: <RequirePermission feature='ai.analytics_v2'>
                <AiReportChatPage />
            </RequirePermission>
        },
        {
            path: '/accounts/:accountId/activities/:activityId/mediaMix/list',
            element: <MediaMixLists />
        },
        {
            path: '/accounts/:accountId/activities/:activityId/mediaMix/:mediaMixId/approval',
            element: <MediaMixApproval />
        },
        {
            path: '/accounts/:accountId/activities/:activityId/mediaMix/:mediaMixId/stats',
            element: <MediaMixReport />
        },
        // {
        //     path: '/accounts/:accountId/:subaccountId/activities/:activityId/mediaMix/list',
        //     element: <MediaMixLists />
        // },
        // {
        //     path: '/accounts/activities/mediaMix/:mediaMixid/mediaChannels',
        //     element: <MediaMixChannels />
        // },
        {
            path: '/campaigns/list',
            element: <CampaignsLists />
        },
       
        // {
        //     path: '/connectors/list',
        //     element: <ConnectorsLists />
        // },
        {
            path: '/customColumns/list',
            element: <RequirePermission permissions={[PermissionTypeEnum.GeneralSettings]}>
                <CustomColumnsList />
                </RequirePermission>
        },
        {
            path: '/templates/list',
            element: <RequirePermission permissions={[PermissionTypeEnum.GeneralSettings]}>
                <TemplatesList />
                </RequirePermission>
        },
        
        {
            path: '/users/list',
            element: <RequirePermission permissions={[PermissionTypeEnum.GeneralSettings]}>
                <UsersLIst />
                </RequirePermission>
        },
        {
            path: '/users/:id/maint',
            element: <RequirePermission permissions={[PermissionTypeEnum.GeneralSettings]}>
                <UserEdit />
                </RequirePermission>
        },
        {
            path: '/widget/statistics',
            element: <WidgetStatistics />
        },
        {
            path: '/widget/data',
            element: <WidgetData />
        },
        {
            path: '/widget/chart',
            element: <WidgetChart />
        },

        {
            path: '/user/social-profile/:tab',
            element: <AppUserSocialProfile />
        },
        {
            path: '/user/account-profile/profile1',
            element: <AppUserAccountProfile1 />
        },
        {
            path: '/user/account-profile/profile2',
            element: <AppUserAccountProfile2 />
        },
        {
            path: '/user/account-profile/profile3',
            element: <AppUserAccountProfile3 />
        },

        {
            path: '/user/card/card1',
            element: <AppProfileCardStyle1 />
        },
        {
            path: '/user/card/card2',
            element: <AppProfileCardStyle2 />
        },
        {
            path: '/user/card/card3',
            element: <AppProfileCardStyle3 />
        },
        {
            path: '/user/list/list1',
            element: <AppProfileListStyle1 />
        },
        {
            path: '/user/list/list2',
            element: <AppProfileListStyle2 />
        },

        {
            path: '/customer/customer-list',
            element: <AppCustomerList />
        },
        {
            path: '/customer/order-list',
            element: <AppCustomerOrderList />
        },
        {
            path: '/customer/create-invoice',
            element: <AppCustomerCreateInvoice />
        },
        {
            path: '/customer/order-details',
            element: <AppCustomerOrderDetails />
        },
        {
            path: '/customer/product',
            element: <AppCustomerProduct />
        },
        {
            path: '/customer/product-review',
            element: <AppCustomerProductReview />
        },

        {
            path: '/app/chat',
            element: <AppChat />
        },
        {
            path: '/app/mail',
            element: <AppMail />
        },
       
        {
            path: '/app/calendar',
            element: <AppCalendar />
        },
        {
            path: '/app/contact/c-card',
            element: <AppContactCard />
        },
        {
            path: '/app/contact/c-list',
            element: <AppContactList />
        },
        {
            path: '/components/text-field',
            element: <FrmComponentsTextfield />
        },
        {
            path: '/components/button',
            element: <FrmComponentsButton />
        },
        {
            path: '/components/checkbox',
            element: <FrmComponentsCheckbox />
        },
        {
            path: '/components/radio',
            element: <FrmComponentsRadio />
        },
        {
            path: '/components/autocomplete',
            element: <FrmComponentsAutoComplete />
        },
        {
            path: '/components/slider',
            element: <FrmComponentsSlider />
        },
        {
            path: '/components/switch',
            element: <FrmComponentsSwitch />
        },
        {
            path: '/components/date-time',
            element: <FrmComponentsDateTime />
        },

        {
            path: '/forms/layouts/layouts',
            element: <FrmLayoutLayout />
        },
        {
            path: '/forms/layouts/multi-column-forms',
            element: <FrmLayoutMultiColumnForms />
        },
        {
            path: '/forms/layouts/action-bar',
            element: <FrmLayoutActionBar />
        },
        {
            path: '/forms/layouts/sticky-action-bar',
            element: <FrmLayoutStickyActionBar />
        },

        {
            path: '/forms/frm-autocomplete',
            element: <FrmAutocomplete />
        },
        {
            path: '/forms/frm-mask',
            element: <FrmMask />
        },
        {
            path: '/forms/frm-clipboard',
            element: <FrmClipboard />
        },
        {
            path: '/forms/frm-recaptcha',
            element: <FrmRecaptcha />
        },
        {
            path: '/forms/frm-wysiwug',
            element: <FrmWysiwugEditor />
        },
        {
            path: '/forms/frm-modal',
            element: <FrmModal />
        },
        {
            path: '/forms/frm-tooltip',
            element: <FrmTooltip />
        },

        {
            path: '/tables/tbl-basic',
            element: <TableBasic />
        },
        {
            path: '/tables/tbl-dense',
            element: <TableDense />
        },
        {
            path: '/tables/tbl-enhanced',
            element: <TableEnhanced />
        },
        {
            path: '/tables/tbl-data',
            element: <TableData />
        },
        {
            path: '/tables/tbl-customized',
            element: <TableCustomized />
        },
        {
            path: '/tables/tbl-sticky-header',
            element: <TableStickyHead />
        },
        {
            path: '/tables/tbl-collapse',
            element: <TableCollapsible />
        },

        {
            path: 'forms/charts/apexchart',
            element: <ChartApexchart />
        },
        {
            path: '/forms/charts/orgchart',
            element: <OrgChartPage />
        },
        {
            path: '/forms/forms-validation',
            element: <FrmFormsValidation />
        },
        {
            path: '/forms/forms-wizard',
            element: <FrmFormsWizard />
        },

        {
            path: '/basic/accordion',
            element: <BasicUIAccordion />
        },
        {
            path: '/basic/avatar',
            element: <BasicUIAvatar />
        },
        {
            path: '/basic/badges',
            element: <BasicUIBadges />
        },
        {
            path: '/basic/breadcrumb',
            element: <BasicUIBreadcrumb />
        },
        {
            path: '/basic/cards',
            element: <BasicUICards />
        },
        {
            path: '/basic/chip',
            element: <BasicUIChip />
        },
        {
            path: '/basic/list',
            element: <BasicUIList />
        },
        {
            path: '/basic/tabs',
            element: <BasicUITabs />
        },

        {
            path: '/advance/alert',
            element: <AdvanceUIAlert />
        },
        {
            path: '/advance/dialog',
            element: <AdvanceUIDialog />
        },
        {
            path: '/advance/pagination',
            element: <AdvanceUIPagination />
        },
        {
            path: '/advance/progress',
            element: <AdvanceUIProgress />
        },
        {
            path: '/advance/rating',
            element: <AdvanceUIRating />
        },
        {
            path: '/advance/snackbar',
            element: <AdvanceUISnackbar />
        },
        {
            path: '/advance/skeleton',
            element: <AdvanceUISkeleton />
        },
        {
            path: '/advance/speeddial',
            element: <AdvanceUISpeeddial />
        },
        {
            path: '/advance/timeline',
            element: <AdvanceUITimeline />
        },
        {
            path: '/advance/toggle-button',
            element: <AdvanceUIToggleButton />
        },
        {
            path: '/advance/treeview',
            element: <AdvanceUITreeview />
        },

        {
            path: '/pages/price/price1',
            element: <PagesPrice1 />
        },
        {
            path: '/pages/price/price2',
            element: <PagesPrice2 />
        },

        {
            path: '/utils/util-typography',
            element: <UtilsTypography />
        },
        {
            path: '/utils/util-color',
            element: <UtilsColor />
        },
        {
            path: '/utils/util-shadow',
            element: <UtilsShadow />
        },
        {
            path: '/icons/tabler-icons',
            element: <UtilsTablerIcons />
        },
        {
            path: '/icons/material-icons',
            element: <UtilsMaterialIcons />
        },
        {
            path: '/utils/util-animation',
            element: <UtilsAnimation />
        },
        {
            path: '/utils/util-grid',
            element: <UtilsGrid />
        },
        {
            path: '/sample-page',
            element: <SamplePage />
        },
        {
            path: '/dashboard/default',
            element: <DashboardDefault />
        },
        // {
        //     path: '/analytics',
        //     element: <DashboardAnalytics />
        // },
           {
            path: '/dashboard/managerDashboard_old',
            element: <RequirePermission permissions={[PermissionTypeEnum.ManagementReports]}>
                        <Dashboard/>
                    </RequirePermission>
        }, 
        {
            path: '/dashboard/managerDashboard',
            element: <RequirePermission permissions={[PermissionTypeEnum.ManagementReports]}>
                        <Dashboard2/>
                    </RequirePermission>
        },
        {
            path: '/dashboard/mediaDashboard2',
            element: <RequirePermission permissions={[PermissionTypeEnum.ManagementReports]}>
                        <MediaDashboard2/>
                    </RequirePermission>
        },
       
        
        {
            path: '/forbidden',
            element: <ForbiddenAccess />
        } ,{
            path: '/forbidden1',
            element: <ForbiddenAccess1 />
        }
    ]
};

export default MainRoutes;
